<template>
  <div class="cretification-pop-box">
    <!-- App外部 -->
    <div class="cretification-pop" v-if="versionApp == 1">
      <span class="close-btn" @click="closePop"></span>
      <header class="cretification-title">{{$t('guild_bind_notice_title')}}</header>
      <div class="cretification-content">{{$t('certi_tips1')}}</div>
      <div class="cretification-btn" @click="closePop">OK</div>
    </div>
    <!-- 版本过低 -->
    <div class="cretification-pop" v-if="versionApp == 2">
      <span class="close-btn" @click="closePop"></span>
      <header class="cretification-title">{{$t('guild_bind_notice_title')}}</header>
      <div class="cretification-content">{{$t('certi_tips3')}}</div>
      <div class="cretification-btn" @click="closePop">OK</div>
    </div>
    <!-- 版本合适 未认证 -->
    <div class="cretification-pop" v-if="versionApp == 3">
      <span class="close-btn" @click="closePop"></span>
      <header class="cretification-title">{{$t('guild_bind_notice_title')}}</header>
      <div class="cretification-content">{{$t('certi_tips4')}}</div>
      <div class="cretification-btn" @click="toAuth">{{$t('certi_tips2')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cretification-pop",
  props: {
    // 接口返回的错误码（501915 / 501918），用于区分调用 App 端不同方法
    errCode: {
      type: Number,
      default: 0,
    },
    // 认证入口来源，传给客户端区分业务页面埋点。
    pageSource: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      token: "",
      uid: "",
      lang: "",
      deviceId: "",
      version: "3.0",
      // 1非App内  2版本需升级 3去认证
      versionApp:1
    };
  },
  // 初始化：鉴权/语言/空表单/缓存回填/拉取结算信息
  created() {
    this.initAuth();
    this.initLang();
    // 根据 App 环境与版本号决定弹窗展示类型：
    // 1 = 非 App 内；2 = 版本过低需升级；3 = 版本满足可去认证
    const version = this.getAppVersion();
    if (!version) {
      // 不在 App 内 → 提示"去 App 内部完成认证"
      this.versionApp = 1;
    } else if (this.isVersionEnough("2.12.0")) {
      // 版本满足 → 提示"去认证"
      this.versionApp = 3;
    } else {
      // 版本过低 → 提示"升级"
      this.versionApp = 2;
    }
  },
  methods: {
     // 关闭弹窗：通知父组件隐藏
    closePop() {
      this.$emit('close');
    },
    // 将认证入口来源上报给客户端；埋点失败不能阻断用户进入认证页。
    pushPageSource() {
      if (!this.pageSource) return;
      try {
        this.$completes.complete('pushPageSource', this.pageSource);
      } catch (e) {
        /* 客户端暂未支持该方法时继续执行认证跳转 */
      }
    },
    // 去认证：先上报页面来源，再根据错误码调用对应认证页面。
    toAuth(){
      this.pushPageSource();
      
      // 501912、501918、501923 归为性别认证失败场景。
      if (this.errCode === 501918 || this.errCode === 501912 || this.errCode === 501923) {
        this.$completes.complete('pushPreRealGenderPage')
      } else {
        // 501915（及其他）进入真人认证。
        this.$completes.complete('pushPreRealPersonPage')
      }
      this.closePop()
    },
    // 从 localStorage 初始化鉴权信息
    initAuth() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = data.deviceId || "";
        this.version = data.version || "3.0";
      } catch (e) {
        /* ignore */
      }
    },
    // 初始化 i18n 语言：将浏览器语言映射到支持的语言码并同步 html lang
    initLang() {
      const lang = this.lang || navigator.language;
      const langs = String(lang).substring(0, 2);
      const map = {
        zh: lang === "zh-TW" || lang === "zh-HK" ? "tc" : "zh",
        en: "en",
        ar: "ar",
        tr: "tr",
        es: "es",
        pt: "pt",
        fr: "fr",
        id: "id",
        ms: "ms",
      };
      this.$i18n.locale = map[langs] || "en";
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    // 获取当前 App 版本号（仅从 UA 中解析）
    // 若 UA 中存在 "app/xxx:版本号" 标记则返回版本号；否则返回 null（表示不在 App 内）
    getAppVersion() {
      // 从 UA 解析：格式形如 "app/layla:2.10.0"
      const ua = navigator.userAgent;
      const match = ua.match(/app\/[^:\s]+:(\d+(?:\.\d+)+)/);
      if (match) {
        return match[1];
      }
      // UA 中无版本标记，说明不在 App 内
      return null;
    },
    // 版本号字符串转为数字数组：[主版本, 次版本, 修订版本]，便于逐段比较
    parseVersion(version) {
      const parts = String(version || "").split(".");
      return [
        parseInt(parts[0], 10) || 0,
        parseInt(parts[1], 10) || 0,
        parseInt(parts[2], 10) || 0,
      ];
    },
    // 判断当前 App 版本是否大于等于目标版本号
    // @param {string} minVersion 目标版本号，如 "2.10.0"
    // @returns {boolean} 当前版本 >= minVersion 返回 true
    isVersionEnough(minVersion) {
      const cur = this.parseVersion(this.getAppVersion());
      const min = this.parseVersion(minVersion);
      // 逐段比较（主版本 → 次版本 → 修订版本），前面相等才比较下一位
      for (let i = 0; i < 3; i++) {
        if ((cur[i] || 0) > (min[i] || 0)) return true;
        if ((cur[i] || 0) < (min[i] || 0)) return false;
      }
      // 三段全部相等，视为满足（>=）
      return true;
    },
  },
};
</script>

<style scoped>
.cretification-pop-box{
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  position: fixed;
  left: 0;
  top: 0;
  z-index:101;
}
.cretification-pop{
  width: 584px;
  /* min-height: 390px; */
  border-radius: 24px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  padding: 24px 32px;
  box-sizing: border-box;
}
.close-btn{
  position: absolute;
  top: 26px;
  right: 32px;
  width: 36px;
  height: 36px;
  background: url('../../assets/withdrawal/close.svg') no-repeat;
  background-size: 100% 100%;
}
.cretification-title{
  font-size: 28px;
  font-weight: 600;
  color: #262427;
  margin-bottom: 24px;
}
.cretification-content{
  font-size: 26px;
  line-height: 40px;
  color: #262427;
  margin-bottom: 24px;
}
.cretification-btn{
  width: 452px;
  height: 92px;
  border-radius: 28px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  background: #8131E7;
  margin: 0 auto;
  line-height: 92px;
}
</style>
